/** Turn { "a.b": 1 } style flattened keys back into nested objects/arrays. */
export const unFlattenObj = (data, seperator = ".") => {
  let result = {};
  for (let i in data) {
    let keys = i.split(seperator);
    keys.reduce((acc, value, index) => {
      return (
        acc[value] ||
        (acc[value] = isNaN(Number(keys[index + 1]))
          ? keys.length - 1 === index
            ? data[i]
            : {}
          : [])
      );
    }, result);
  }
  return result;
};

/** Fields that never show up in the record-history diff. */
const EXCLUDED_HISTORY_FIELDS = [
  "id",
  "Modified_Time",
  "Created_Time",
  "Last_Activity_Time",
  "Full_Name",
  "Currency",
  "Email_Opt_Out",
  "Exchange_Rate",
];

/** Parse and unflatten the record_response payload of each history row. */
export const unflattenDbRecords = (rows) =>
  (rows || []).map((current_value) => ({
    ...current_value,
    record_response: unFlattenObj(
      typeof current_value?.record_response === "string"
        ? JSON.parse(current_value?.record_response)
        : current_value?.record_response
    ),
  }));

/**
 * Reduce each history snapshot to only the fields that changed compared to
 * the next (older) snapshot, skipping internal ($-prefixed) and excluded fields.
 */
export const filterChangedRecordFields = (records) =>
  (records || []).map((current_value, index) => {
    const filtered_record_response = {};
    const next_value = records[index + 1];

    Object.keys(current_value?.record_response).forEach((field_api_name) => {
      if (
        field_api_name.includes("$") ||
        EXCLUDED_HISTORY_FIELDS.includes(field_api_name)
      ) {
        return;
      }

      const currentField = current_value?.record_response[field_api_name];
      const nextField = next_value?.record_response?.[field_api_name];

      // lookup-style values compare by name
      if (typeof currentField === "object" && currentField) {
        if (currentField.name === nextField?.name) {
          return;
        }
      } else if (currentField === nextField) {
        return;
      }

      filtered_record_response[field_api_name] = currentField;
    });

    return {
      ...current_value,
      record_response: filtered_record_response,
    };
  });
